export const ADMIN_PAGE_SX = {
  bgcolor: "background.default",
  minHeight: "100%",
};

export const ADMIN_TOOLBAR_SX = {
  display: "flex",
  gap: 2,
  flexWrap: "wrap",
  alignItems: "center",
};

export const ADMIN_SECTION_SX = {
  bgcolor: "background.paper",
  borderColor: "divider",
  p: 2,
};

export const ADMIN_METRIC_SX = {
  bgcolor: "background.paper",
  borderColor: "divider",
  p: 2,
  height: "100%",
};
